// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import store from './store'

//Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './filters'

Vue.config.productionTip = false

Vue.use(ElementUI);

var config = {
    apiKey: "AIzaSyByJeZKDc1qeisLrL2OulbDhEbIB5UIYTg",
    authDomain: "zoom-7fe6d.firebaseapp.com",
    databaseURL: "https://zoom-7fe6d.firebaseio.com",
    projectId: "zoom-7fe6d",
    storageBucket: "zoom-7fe6d.appspot.com",
    messagingSenderId: "903760514310"
};

firebase.initializeApp(config);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js